<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../provider.js';
import { MESSAGE_TYPES } from '../constants';
import BaseBubble from './Base.vue';
import FormattedContent from './Text/FormattedContent.vue';
import Icon from 'next/icon/Icon.vue';

const { content, messageType } = useMessageContext();

const isUserVoice = computed(
  () => messageType.value === MESSAGE_TYPES.INCOMING
);

const voiceIcon = computed(() =>
  isUserVoice.value ? 'i-lucide-mic' : 'i-lucide-headset'
);

const voiceLabel = computed(() =>
  isUserVoice.value ? 'Transcrição de voz' : 'Resposta por voz (IA)'
);

const bubbleClass = computed(() =>
  isUserVoice.value
    ? 'bg-n-teal-3 border border-n-teal-7 text-n-slate-12'
    : 'bg-n-iris-3 border border-n-iris-7 text-n-slate-12'
);

const accentClass = computed(() =>
  isUserVoice.value ? 'text-n-teal-11' : 'text-n-iris-11'
);
</script>

<template>
  <BaseBubble
    class="px-4 py-3"
    :class="bubbleClass"
    data-bubble-name="voice-transcript"
  >
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-1.5">
        <Icon :icon="voiceIcon" class="size-3.5" :class="accentClass" />
        <span class="text-xs font-medium" :class="accentClass">
          {{ voiceLabel }}
        </span>
      </div>
      <FormattedContent v-if="content" :content="content" />
    </div>
  </BaseBubble>
</template>
